import { t } from '@lingui/core/macro';

import { type AudienceOptionType } from '@/api/audience';
import { TRAFFIC_TYPES } from '@/api/common';
import { Legend, LegendItem } from '@/components/Legend';
import {
  AUDIENCE_PRIMARY,
  BOT_PRIMARY,
  TAM_PRIMARY,
  UNKNOWN_PRIMARY,
  VISITS_PRIMARY,
} from '@/constants';

type Props = {
  audience?: AudienceOptionType;
  hiddenSeries?: TRAFFIC_TYPES[];
  onDisabledSeriesChange: (disabledSeriesType?: TRAFFIC_TYPES[]) => void;
};

const VisitActivityLegend = ({ audience, hiddenSeries = [], onDisabledSeriesChange }: Props) => {
  return (
    <Legend<TRAFFIC_TYPES> className="-mx-6 -mbs-4" onDisabledSeriesChange={onDisabledSeriesChange}>
      {audience?.isTAM ? (
        <LegendItem value={TRAFFIC_TYPES.TAM} color={TAM_PRIMARY} name={t`TAM`} />
      ) : (
        <LegendItem value={TRAFFIC_TYPES.AUDIENCE} color={AUDIENCE_PRIMARY} name={audience?.name} />
      )}
      <LegendItem value={TRAFFIC_TYPES.OTHER} color={VISITS_PRIMARY} name={t`Other Companies`} />
      {!hiddenSeries.includes(TRAFFIC_TYPES.BOT) && (
        <LegendItem value={TRAFFIC_TYPES.BOT} color={BOT_PRIMARY} name={t`Bot`} />
      )}
      {!hiddenSeries.includes(TRAFFIC_TYPES.UNRESOLVED) && (
        <LegendItem value={TRAFFIC_TYPES.UNRESOLVED} color={UNKNOWN_PRIMARY} name={t`Unknown`} />
      )}
    </Legend>
  );
};

export default VisitActivityLegend;
